'use client';

import { type PropsWithChildren, type ReactNode } from 'react';

import {
  ON_IDENTIFIER,
  type OpzlyExperimentName,
  VARIANT_IDENTIFIER,
} from './config';
import { useExperiments } from './useExperiments';

interface WrapperProps extends PropsWithChildren {
  experiment: OpzlyExperimentName;
  fallback?: ReactNode;
}

export function ExperimentWrapper({
  experiment,
  fallback,
  children,
}: WrapperProps) {
  const { [experiment]: exp } = useExperiments([experiment]);

  if ([VARIANT_IDENTIFIER, ON_IDENTIFIER].includes(exp)) {
    return children;
  }
  return fallback ?? null;
}
